export const cleanStore = () => ({
    type: "CLEAN_STORE",
});
